import { Box, Typography } from '@mui/material';

import { TableBodySkeleton } from '../../../../common/components';

export const DashboardMetric = ({ label, value, helper }) => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'primary.main',
      borderRadius: 1,
      backgroundColor: 'background.paper',
      minHeight: 78,
      px: 1.5,
      py: 1.25,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minWidth: 0,
    }}
  >
    <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 800, lineHeight: 1.2 }}>
      {label}
    </Typography>
    <Typography
      variant="h6"
      sx={{
        color: 'primary.main',
        fontWeight: 900,
        lineHeight: 1.2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
      title={String(value || '-')}
    >
      {value || '-'}
    </Typography>
    {helper && (
      <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, lineHeight: 1.2 }}>
        {helper}
      </Typography>
    )}
  </Box>
);

export const DashboardChartCard = ({ title, children, loading = false, hasData = true, height = 300 }) => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      backgroundColor: 'background.paper',
      minWidth: 0,
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        px: 1.75,
        py: 1.25,
        borderBottom: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
      }}
    >
      <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 800 }}>
        {title}
      </Typography>
    </Box>
    <Box sx={{ height, p: 1.5, minWidth: 0 }}>
      {loading ? (
        <TableBodySkeleton rows={4} variant="box" />
      ) : hasData ? children : (
        <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600 }}>
            Sin datos para graficar
          </Typography>
        </Box>
      )}
    </Box>
  </Box>
);
